module.exports = Promise.all([parcelRequire.load("iCdWd"), parcelRequire.load("dVqC0"), parcelRequire.load("Ody1Y")]).then(() => parcelRequire('hXvkB'));